import React, { useRef, useState } from "react";

import "../../styles/BusHeatmapChart.css";
import { BusMapData } from "../../types/app.types";
import { useHeatmapData } from "../../hooks/use_heatmap_data";
import { BusLayoutInfo } from "./BusLayoutInfo";
import { CapacityChart } from "./CapacityChart";
import { HeatmapControls } from "./HeatmapControls";
import { HeatmapTable } from "./HeatmapTable";

interface BusHeatmapChartProps {
  data: BusMapData;
  route: string;
}

export const BusHeatmapChart: React.FC<BusHeatmapChartProps> = ({ data }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [useMaxDensity, setUseMaxDensity] = useState(true);
  const [showPercentage, setShowPercentage] = useState(true);

  const transformedData = useHeatmapData(data, useMaxDensity);

  if (!data || !data.stops || data.stops.length === 0) {
    return (
      <div className="heatmap-error">
        <span className="heatmap-error-icon">⚠️</span>
        <p className="heatmap-error-text">
          Не вдалося завантажити дані про зупинки для цього маршруту. Карта не
          може бути побудована.
        </p>
      </div>
    );
  }

  if (!transformedData) {
    return null;
  }

  const hasMaxDensityData = !!(
    data.maxDensitySeatList && data.maxDensitySeatList.length > 0
  );
  const isFixedSeating = data.statistics.isFixedSeating;

  const {
    matrix,
    tooltipData,
    indexToColor,
    segmentBoundaries,
    shortenedStopNames,
    stopNames,
    generalAmounts,
  } = transformedData;

  return (
    <div className="heatmap-container">
      <div className="bus-layout-info">
        <BusLayoutInfo data={data} isFixedSeating={isFixedSeating} />
        <HeatmapControls
          useMaxDensity={useMaxDensity}
          onToggleDensity={() => setUseMaxDensity(!useMaxDensity)}
          hasMaxDensityData={hasMaxDensityData}
          isFixedSeating={isFixedSeating}
        />
      </div>

      <div ref={containerRef}>
        <HeatmapTable
          matrix={matrix}
          tooltipData={tooltipData}
          indexToColor={indexToColor}
          segmentBoundaries={segmentBoundaries}
          shortenedStopNames={shortenedStopNames}
          stopNames={stopNames}
          generalAmounts={generalAmounts}
          useMaxDensity={useMaxDensity}
        />
      </div>

      <div className="seating-details">
        <CapacityChart
          stops={data.stops}
          totalSeats={data.statistics.totalSeats}
          showPercentage={showPercentage}
          onToggleMode={setShowPercentage}
        />
      </div>
    </div>
  );
};
